<template>
  <div class="today">
    <Toast />
    <div class="tableContainer mx-auto">
      <h4>Today's transactions</h4>
      <div class="card table-view">
        <DataTable
          :value="today_transaction"
          :paginator="true"
          class="p-datatable-customers"
          :rows="10"
          v-model:selection="selectedProducts3"
          dataKey="id"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:filters="filters2"
          filterDisplay="row"
          :loading="LoadingData"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          :globalFilterFields="[
            'refid',
            'fullname',
            'amount',
            'type',
            'date',
          ]"
        >
          <template #header>
            <div class="p-d-flex p-jc-end">
              <span class="p-input-icon-left ">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters2['global'].value"
                  placeholder="Keyword Search"
                />
              </span>
            </div>
          </template>
          <template #empty>
            No transactions found.
          </template>
          <template #loading>
            Loading transactions data. Please wait.
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column
            field="refid"
            header="Transaction Id"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.refid }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['refid'].value"
                class="p-column-filter"
                :placeholder="`Search by id - `"
              />
            </template>
          </Column>

          <Column
            field="fullname"
            header="Full name"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.fullname }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['fullname'].value"
                class="p-column-filter"
                :placeholder="`Search by name - `"
              />
            </template>
          </Column>

          <Column
            field="amount"
            header="Amount"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}"> {{ data.amount }}Frw </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['amount'].value"
                class="p-column-filter"
                :placeholder="`Search by amount - `"
              />
            </template>
          </Column>

          <Column
            field="type"
            header="Payment method"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}"> {{ data.type }}Frw </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['type'].value"
                class="p-column-filter"
                :placeholder="`Search by payment method - `"
              />
            </template>
          </Column>
          <Column
            field="date"
            header="Date"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.date }} &nbsp; at &nbsp;{{ data.time }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['date'].value"
                class="p-column-filter"
                :placeholder="`Search by payment method - `"
              />
            </template>
          </Column>
        </DataTable>
      </div>

 <!-- table card for mobile -->

      <div class="card mobile_cards_instead_of_table ">
        <DataView
          :value="today_transaction"
          :paginator="true"
          :rows="9"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <template #empty>
            No transactions found.
          </template>
          <template #list="slotProps">
            <div class="p-col-12">
              <div class="col-sm-12 col-12 single-card">
                <div class="sub-content d-flex">
                  <p class="title">Transaction id:</p>
                  <p class="content pl-2">{{ slotProps.data.refid }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Full name:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.fullname }}
                  </p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Amount:</p>
                  <p class="content pl-2">{{ slotProps.data.amount }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Payment method:</p>
                  <p class="content pl-2">{{ slotProps.data.type }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Date:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.date }} at {{ slotProps.data.time }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </DataView>
      </div>

      <div class="d-flex loader" v-if="LoadingData">
        <span
          v-if="true"
          class="spinner-border spinner-border-sm ml-2 my-auto"
        ></span>
        <p>Please wait. We are loading data...</p>
      </div>


    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import axios from "axios";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};

export default {
  data() {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        refid: { value: null, matchMode: FilterMatchMode.CONTAINS },
        amount: { value: null, matchMode: FilterMatchMode.CONTAINS },
        fullname: { value: null, matchMode: FilterMatchMode.CONTAINS },
        type: { value: null, matchMode: FilterMatchMode.CONTAINS },
        date: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      LoadingData: true,
      today_transaction: [],
    };
  },
  created() {
 
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if ( userRole != "shaloi") {
          return router.push("/dashboard");
    }
  },
  mounted() {
    //API Call
    axios
      .get(
        "https://bookinga.herokuapp.com/api/v1/transaction/today/branch",
        config
      )
      .then((res) => {
        this.today_transaction = res.data.data;
        this.LoadingData = false;
      })
      .catch((err) => {
        this.LoadingData = false;
        return this.$toast.add({
          severity: "warn",
          summary: "You don't manage any branch in bookinga yet",
          detail: "Contact your admin to assign you a branch",
          // life: 10000,
        });
      });
  },
};
</script>
<style lang="scss" scoped>
@import "../../companyAdmin/sharedStyles.scss";
h4 {
  color: $gradientDark;
  margin-bottom: 0.5%;
  // margin-left: 1%;
  font-size: 0.9em;
  margin-top: 2%;
}
.table-container {
  margin: 0.7rem;
  width: 97%;
}
table {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.096);
}
th {
  font-weight: 500;
  font-size: 1em !important;
}
</style>
